import { Text } from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { Stack, ThemeProvider } from "@mui/material";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";

import { PageWrapper } from "../../components/PageWrapper";
import { SelectableBox } from "../../components/SelectableBox";
import { PageContent } from "../../WorkerShifts/components/PageContent";

export function OutagePageContent() {
  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <PageContent sx={(theme) => ({ paddingTop: theme.spacing(4) })}>
          <Stack flex={1} spacing={5} mt={8}>
            <Text variant="h3" textAlign="center">
              The app is experiencing an outage
            </Text>
            <Text variant="body1" textAlign="center">
              We&apos;re so sorry. Currently, shift invites are still functional. Currently only the
              open shifts view is affected. Existing bookings work as normal. We&apos;re working on
              getting the app operational as soon as possible. Reach out to support if you have any
              questions.
            </Text>
            <SelectableBox
              withCallToActionIcon
              startIconType="text-bubble"
              sx={{ textAlign: "left" }}
              onClickCapture={async () => {
                await openZendeskMessaging();
              }}
            >
              Chat with support
            </SelectableBox>
          </Stack>
        </PageContent>
      </PageWrapper>
    </ThemeProvider>
  );
}
